<h1 mat-dialog-title class="p-2 text-center">Ajout d'une plage horaire</h1>
<div mat-dialog-content class="p-3">
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Début</mat-label>
            <input matInput placeholder="Début" [matDatepicker]="picker1" [(ngModel)]="Debut" (click)="picker1.open()" (dateChange)="debutChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="col">
            <mat-label>Heure</mat-label>
            <input matInput placeholder="Heure" [format]="24" [ngxTimepicker]="timepicker1" [value]="interventionTimeDebut" readonly>
            <ngx-material-timepicker #timepicker1 (timeSet)="timeSetDebut($event)"></ngx-material-timepicker>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Fin</mat-label>
            <input matInput placeholder="Fin" [matDatepicker]="picker2" [(ngModel)]="Fin" (click)="picker2.open()" (dateChange)="finChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="col">
            <mat-label>Heure</mat-label>
            <input matInput placeholder="Heure" [format]="24" [ngxTimepicker]="timepicker2" [value]="interventionTimeFin" readonly>
            <ngx-material-timepicker #timepicker2 (timeSet)="timeSetFin($event)"></ngx-material-timepicker>
        </mat-form-field>
    </div>
    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!canSave()">
            Valider
        </button>
    </div>
</div>